/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { LIST_REPORT4 } from "./actionTypes"
import { listReport4Error, listReport4Success } from "./actions"

//Include Both Helper File with needed methods
import { report4NewApi } from "../../../helpers/backend_helper"

function* list(request) {
  try {
    const response = yield call(report4NewApi, request.payload.form)
    if (response === undefined) throw new Error("API error")
    if (response.length === undefined) throw new Error(response)
    yield put(listReport4Success(response))
  } catch (error) {
    console.log(error.message)
    yield put(listReport4Error(error.message))
  }
}

function* report4ListSaga() {
  yield takeEvery(LIST_REPORT4, list)
}

export default report4ListSaga
